/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbsencesModule } from '@absences/absences.module';
import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import germanLocale from '@angular/common/locales/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { CustomDateAdapter } from '@app/custom-date-adapter';
import { UserModule } from '@app/user/user.module';
import { AuthModule } from '@auth/auth.module';
import { ConstructionSitesModule } from '@construction-sites/construction-sites.module';
import { CoreModule } from '@core/core.module';
import { CustomersModule } from '@customers/customers.module';
import { DepartmentsModule } from '@departments/departments.module';
import { DriversModule } from '@drivers/drivers.module';
import { environment } from '@env/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '@shared/shared.module';
import { ToursModule } from '@tours/tours.module';
import { VehiclesModule } from '@vehicles/vehicles.module';
import { AngularSplitModule } from 'angular-split';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { getSentryProviders } from './sentry';

registerLocaleData(germanLocale, 'de');

if (environment.releaseHash === 'dev') {
  environment.releaseHash = Date.now().toString();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    SharedModule,
    AuthModule,
    CoreModule,
    DepartmentsModule,
    DriversModule,
    ToursModule,
    VehiclesModule,
    UserModule,
    AbsencesModule,
    ConstructionSitesModule,
    CustomersModule,
    AppRoutingModule,
    MatNativeDateModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot(),
    AngularSplitModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
      appearance: 'outline',
      floatLabel: 'always',
     // subscriptSizing: 'dynamic',
    }},
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 10000 } },
    { provide: MAT_TABS_CONFIG, useValue: { stretchTabs: false } },
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json?t=' + environment.releaseHash }),
    provideHttpClient(withInterceptorsFromDi()),
    ...getSentryProviders()
  ]
})
export class AppModule {
  constructor(
    private translateService: TranslateService,
    private dateAdapter: DateAdapter<any>,
  ) {
    translateService.use(environment.language);
    dateAdapter.setLocale('de');
  }
}
